import { ClassNames, css } from '@emotion/react';

import Tooltip from 'rc-tooltip';
import React from 'react';
import { User } from './GraphQLHelpers';

import { timeAgo } from '@mythos/utils/dateUtils';
import 'rc-tooltip/assets/bootstrap_white.css';
import { UIColorPalette } from './ColorPalette';
import Styles from './Styles';

export default function UserHoverView(props: {
  user: User;
  children: React.ReactElement;
}) {
  return (
    <ClassNames>
      {({ css }) => (
        <Tooltip
          placement="left"
          showArrow={{
            className: css({ borderLeftColor: UIColorPalette.backgroundWhite }),
          }}
          overlay={<UserHoverTooltip user={props.user} />}
          destroyTooltipOnHide
        >
          {props.children}
        </Tooltip>
      )}
    </ClassNames>
  );
}

function UserHoverTooltip(props: { user: User }) {
  const link = props.user.profileURL;
  const stats = props.user.stats;
  return (
    <div css={UserHoverStyles.userHoverTooltip}>
      <div css={[Styles.flexRow, Styles.gap2]}>
        <img
          src={props.user.profilePictureURL}
          css={UserHoverStyles.userAvatar}
        />
        <div
          css={[
            Styles.flexColumn,
            {
              alignItems: 'flex-start',
            },
          ]}
        >
          <div>{props.user.name}</div>
          <div>{props.user.subtitle}</div>
        </div>
      </div>
      {stats ? (
        <>
          <div>Rating: {stats.rating}</div>
          <div>Joined {timeAgo(props.user.createdAt)}</div>
          <div>Games Played: {stats.totalGames}</div>
          <div>Wins: {stats.totalWins}</div>
          <div>
            Avg Blame Time:{' '}
            {stats.totalGames > 0
              ? Math.floor(stats.totalBlameMillis / stats.totalGames / 1000) +
                's'
              : 'N/A'}
          </div>
        </>
      ) : null}
      {link && (
        <a href={link} css={UserHoverStyles.viewProfileLink}>
          View Profile
        </a>
      )}
    </div>
  );
}

const UserHoverStyles = {
  userHoverTooltip: css(Styles.flexColumn, {
    backgroundColor: UIColorPalette.backgroundWhite,
    alignItems: 'flex-start',
  }),
  userAvatar: css({
    width: 32,
    height: 32,
  }),
  arrow: css({
    backgroundColor: UIColorPalette.backgroundWhite,
  }),
  viewProfileLink: css({
    backgroundColor: UIColorPalette.buttonPrimary,
    color: UIColorPalette.buttonPrimaryText,
    border: 'none',
    borderRadius: 2,
    padding: '6px 18px',
    cursor: 'pointer',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'background 0.15s',
    marginTop: 8,
    display: 'inline-block',
    '&:hover': {
      backgroundColor: UIColorPalette.buttonPrimaryHover,
      textDecoration: 'none',
    },
    '&:active': {
      backgroundColor: UIColorPalette.buttonPrimaryActive,
    },
  }),
};
